(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mp-social-menu"] && !Shopify.designMode) return;
  try {
    if (!window.mpSocialMenuInit) {
    window.mpSocialMenuInit = true;
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-mp-social-trigger]');
      var openPanel = document.querySelector('[data-mp-social-panel]:not([hidden])');
      if (trigger) {
        var panel = trigger.closest('[data-mp-social-menu]').querySelector('[data-mp-social-panel]');
        var isOpen = panel.hasAttribute('hidden') === false;
        if (openPanel && openPanel !== panel) {
          openPanel.setAttribute('hidden', '');
          var openTrigger = openPanel.closest('[data-mp-social-menu]').querySelector('[data-mp-social-trigger]');
          if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
        }
        if (isOpen) {
          panel.setAttribute('hidden', '');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          panel.removeAttribute('hidden');
          trigger.setAttribute('aria-expanded', 'true');
        }
        return;
      }
      if (openPanel && !event.target.closest('[data-mp-social-menu]')) {
        openPanel.setAttribute('hidden', '');
        var t = openPanel.closest('[data-mp-social-menu]').querySelector('[data-mp-social-trigger]');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
      if (event.target.closest('[data-mp-social-link]')) {
        var panel2 = event.target.closest('[data-mp-social-panel]');
        if (panel2) {
          panel2.setAttribute('hidden', '');
          var t2 = panel2.closest('[data-mp-social-menu]').querySelector('[data-mp-social-trigger]');
          if (t2) t2.setAttribute('aria-expanded', 'false');
        }
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var openPanel = document.querySelector('[data-mp-social-panel]:not([hidden])');
      if (openPanel) {
        openPanel.setAttribute('hidden', '');
        var trigger = openPanel.closest('[data-mp-social-menu]').querySelector('[data-mp-social-trigger]');
        if (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
